import '@mui/material/styles';
export const breakpoints = {
    values: {
        xs: 0,
        sm: 568,
        md: 768,
        lg: 1024,
        xl: 1280,
        xxl: 1440,
        fhd: 1800 // Custom XXXL
    }
};
